/* eslint-disable */
import moment from 'moment';
export const ilsSignin = {
	data() {
		return {
			ilsSignInComplete: false,
			ilsPatronDetails: {}
		};
	},
	methods: {
		async signInToILS(patronBarcode, patronPin) {
			const pinless = this.clientSettings.client_pinless_auth === true || this.clientSettings.client_pinless_auth === 'true';
			patronBarcode = patronBarcode.trim();
			if (!pinless) {
				patronPin = patronPin.trim();
			}
			this.submitting = true;
			const pinParam = pinless ? '' : `&p=${patronPin}`;
			fetch(
				`${process.env.VUE_APP_API_ENDPOINT}/v1/${this.keyword}/patron?u=${patronBarcode}${pinParam}&type=schedule`,
				{
					method: 'GET',
					headers: { 'Content-Type': 'application/json' }
				}
			)
				.then(async res => {
					if (res.ok) {
						const json = await res.json();
						if (json.result == 'ok') {
							if (
								json.data.blockData &&
								json.data.blockData.result !== 'ok'
							) {
								if (
									json.data.blockData.message &&
									json.data.blockData.message !== ''
								) {
									throw `There has been a problem validating your card details. Please contact your library for assistance`;
								}
							}
							this.ilsPatronDetails.patron = {
								barcode: patronBarcode
							};
							this.form.firstName =
								json.data.names && json.data.names[0]
									? json.data.names[0].first_name.trim()
									: '';
							this.form.lastName =
								json.data.names && json.data.names[0]
									? json.data.names[0].last_name.trim()
									: '';
							this.form.email =
								json.data.emails && json.data.emails[0]
									? json.data.emails[0].trim()
									: '';
							this.form.cell =
								json.data.phones && json.data.phones[0]
									? json.data.phones[0]
										.split(',')[0]
										.replace(/[^+()\-0-9]/g, '')
										.trim()
									: '';
							if (
								this.group.ils_integration_options
									.require_patron_holds == 'true'
							) {
								// Fetch and check holds
								this.ilsPatronDetails.holds = await this.getPatronHoldsFromILS(
									this.clientDetails.ils_type,
									patronBarcode,
									patronPin
								);
								if (
									(this.group.ils_integration_options
										.require_patron_holds == 'true' &&
										this.ilsPatronDetails.holds.length ==
											0) ||
									this.ilsPatronDetails.holds.filter(
										hold => hold.isReady
									).length == 0
								) {
									throw `None of your holds are currently ready, please check back once notification of their arrival has been received`;
								} else {
									console.info(
										`${this.ilsPatronDetails.holds.length} hold(s) available.`
									);
								}
								if (
									this.group.ils_integration_options
										.include_patron_details == 'true'
								) {
									try {
										// Checkouts
										this.ilsPatronDetails.checkouts = await this.getPatronCheckoutsFromILS(
											this.clientDetails.ils_type,
											patronBarcode,
											patronPin
										);
									} catch (e) {
										console.error(e);
									}
									// Fines
									try {
										this.ilsPatronDetails.fines = await this.getPatronFinesFromILS(
											this.clientDetails.ils_type,
											patronBarcode,
											patronPin
										);
									} catch (e) {
										console.error(e);
									}
								}
							}
							this.ilsSignInComplete = true;
							this.submitting = false;
							return;
						} else {
							throw 'Unable to sign in, please check your barcode and PIN number.';
						}
					} else {
						throw 'Invalid details';
					}
				})
				.catch(err => {
					console.error(err);
					this.submitting = false;
					this.showError = true;
					this.errorMessage = err;
				});
		},
		async getPatronHoldsFromILS(ilsType, patronBarcode, patronPin) {
			switch (ilsType) {
				case 'iii':
					let iiiPatronDetails = await (
						await fetch(
							`${process.env.VUE_APP_API_ENDPOINT}/v2/${this.keyword}/sierra/patron/details/${patronBarcode}/${patronPin}`,
							{
								method: 'GET',
								headers: { 'Content-Type': 'application/json' }
							}
						)
					).json();
					let iiiHoldDetails = await (
						await fetch(
							`${process.env.VUE_APP_API_ENDPOINT}/v2/${this.keyword}/sierra/patron/holds/${iiiPatronDetails.data.id}/${patronBarcode}/${patronPin}`,
							{
								method: 'GET',
								headers: { 'Content-Type': 'application/json' }
							}
						)
					).json();
					if (
						iiiHoldDetails.data !== undefined &&
						iiiHoldDetails.data !== null &&
						iiiHoldDetails.data.entries !== undefined
					) {
						return iiiHoldDetails.data.entries.map(hold => {
							return {
								id: parseInt(hold.id, 10),
								frozen: hold.frozen,
								postion: hold.priority,
								queueLength: hold.priorityQueueLength,
								status: hold.status.name,
								pickupLocation: hold.pickupLocation,
								holdDate: hold.placed,
								isReady:
									hold.priority <= 1 &&
									['b', 'j', 'i'].indexOf(
										hold.status.code
									) !== -1,
								bib: null
							};
						});
					} else {
						return [];
					}
					break;
				case 'sirsi':
					let sirsiHoldDetails = await (
						await fetch(
							`${process.env.VUE_APP_API_ENDPOINT}/v2/${this.keyword}/sirsidynix/patron/holds/${patronBarcode}/${patronPin}`,
							{
								method: 'GET',
								headers: { 'Content-Type': 'application/json' }
							}
						)
					).json();
					if (
						sirsiHoldDetails.data !== undefined &&
						sirsiHoldDetails.data !== null &&
						sirsiHoldDetails.data.entries !== undefined
					) {
						return sirsiHoldDetails.data.entries.map(hold => {
							const recordId = hold.key;
							const bib = hold.bib;
							return {
								id: recordId,
								frozen: false,
								postion: hold.queuePosition,
								queueLength: hold.queueLength,
								status: hold.status,
								pickupLocation: {
									code: hold.pickupLocationId,
									name: hold.pickupLocationName,
									position: null
								},
								holdDate: hold.placedDate,
								isReady: hold.status == 'BEING_HELD',
								bib: null
							};
						});
					} else {
						return [];
					}
					break;
				case 'polaris':
					let polarisHoldDetails = await (
						await fetch(
							`${process.env.VUE_APP_API_ENDPOINT}/v1/${this.keyword}/polaris/holdrequests/${patronBarcode}/${patronPin}`,
							{
								method: 'GET',
								headers: { 'Content-Type': 'application/json' }
							}
						)
					).json();
					if (
						polarisHoldDetails.PatronHoldRequestsGetRows !==
							undefined &&
						polarisHoldDetails.PatronHoldRequestsGetRows !== null
					) {
						return polarisHoldDetails.PatronHoldRequestsGetRows.map(
							hold => {
								const bib = null;
								return {
									id: hold.HoldRequestID,
									postion: hold.QueuePosition,
									queueLength: hold.QueueTotal,
									status: hold.StatusDescription,
									pickupLocation: hold.PickupBranchName,
									holdDate: hold.ActivationDate,
									frozen: hold.frozen,
									isReady:
										hold.QueuePosition <= 0 &&
										hold.StatusID < 9,
									bib: null
								};
							}
						);
					} else {
						return [];
					}
					break;
				case 'koha': {
					let kohaHoldDetails = await (
						await fetch(
							`${process.env.VUE_APP_API_ENDPOINT}/v2/${this.keyword}/koha/patron/holds/${patronBarcode}/${patronPin}`,
							{
								method: 'GET',
								headers: { 'Content-Type': 'application/json' }
							}
						)
					).json();
					const entries = kohaHoldDetails?.data?.entries;
					if (Array.isArray(entries)) {
						return entries.map(hold => ({ isReady: hold.isReady }));
					}
					return [];
				}
				break;
			}
		},
		async getPatronCheckoutsFromILS(ilsType, patronBarcode, patronPin) {
			switch (ilsType) {
				case 'iii':
					let iiiPatronDetails = await (
						await fetch(
							`${process.env.VUE_APP_API_ENDPOINT}/v2/${this.keyword}/sierra/patron/details/${patronBarcode}/${patronPin}`,
							{
								method: 'GET',
								headers: { 'Content-Type': 'application/json' }
							}
						)
					).json();
					let iiiCheckoutDetails = await (
						await fetch(
							`${process.env.VUE_APP_API_ENDPOINT}/v2/${this.keyword}/sierra/patron/checkouts/${iiiPatronDetails.data.id}/${patronBarcode}/${patronPin}`,
							{
								method: 'GET',
								headers: { 'Content-Type': 'application/json' }
							}
						)
					).json();
					if (
						iiiCheckoutDetails.data !== undefined &&
						iiiCheckoutDetails.data !== null
					) {
						return iiiCheckoutDetails.data.entries.map(checkout => {
							return {
								id: parseInt(
									checkout.id.substr(
										checkout.id.lastIndexOf('/') + 1
									),
									10
								),
								outDate: checkout.outDate,
								dueDate: moment(checkout.dueDate).format(
									'YYYY-MM-DD'
								),
								renewals: checkout.numberOfRenewals,
								barcode: checkout.barcode,
								bib: null
							};
						});
					} else {
						return [];
					}
					break;
				case 'sirsi':
					let sirsiCheckoutDetails = await (
						await fetch(
							`${process.env.VUE_APP_API_ENDPOINT}/v2/${this.keyword}/sirsidynix/patron/checkouts/${patronBarcode}/${patronPin}`,
							{
								method: 'GET',
								headers: { 'Content-Type': 'application/json' }
							}
						)
					).json();
					if (
						sirsiCheckoutDetails.data !== undefined &&
						sirsiCheckoutDetails.data !== null
					) {
						return sirsiCheckoutDetails.data.entries.map(
							checkout => {
								return {
									id: checkout.id,
									outDate: moment(
										checkout.checkOutDate
									).format('YYYY-MM-DD'),
									dueDate: moment(checkout.dueDate).format(
										'YYYY-MM-DD'
									),
									renewals:
										checkout.renewalCount == null
											? 0
											: checkout.renewalCount,
									barcode: '', //checkout.fields.item.fields.barcode,
									bib: null
								};
							}
						);
					} else {
						return [];
					}
					break;
				case 'polaris':
					let polarisCheckoutDetails = await (
						await fetch(
							`${process.env.VUE_APP_API_ENDPOINT}/v1/${this.keyword}/polaris/itemsout/${patronBarcode}/${patronPin}`,
							{
								method: 'GET',
								headers: { 'Content-Type': 'application/json' }
							}
						)
					).json();
					if (
						polarisCheckoutDetails.PatronItemsOutGetRows !==
							undefined &&
						polarisCheckoutDetails.PatronItemsOutGetRows !== null
					) {
						return polarisCheckoutDetails.PatronItemsOutGetRows.map(
							checkout => {
								const bib = null;
								return {
									id: checkout.ItemID,
									outDate: moment(
										checkout.CheckOutDate
									).format('YYYY-MM-DD'),
									dueDate: moment(checkout.DueDate).format(
										'YYYY-MM-DD'
									),
									renewals: checkout.RenewalCount,
									barcode: checkout.Barcode,
									bib: null
								};
							}
						);
					} else {
						return [];
					}
					break;
			}
		},
		async getPatronFinesFromILS(ilsType, patronBarcode, patronPin) {
			switch (ilsType) {
				case 'iii':
					let iiiPatronDetails = await (
						await fetch(
							`${process.env.VUE_APP_API_ENDPOINT}/v2/${this.keyword}/sierra/patron/details/${patronBarcode}/${patronPin}`,
							{
								method: 'GET',
								headers: { 'Content-Type': 'application/json' }
							}
						)
					).json();
					let iiiFineDetails = await (
						await fetch(
							`${process.env.VUE_APP_API_ENDPOINT}/v2/${this.keyword}/sierra/patron/fines/${iiiPatronDetails.data.id}/${patronBarcode}/${patronPin}`,
							{
								method: 'GET',
								headers: { 'Content-Type': 'application/json' }
							}
						)
					).json();
					if (
						iiiFineDetails.data !== undefined &&
						iiiFineDetails.data !== null
					) {
						return iiiFineDetails.data.entries.map(fine => {
							return {
								id: parseInt(fine.id, 10),
								description: fine.description,
								amountPaid: fine.paid,
								amount: fine.amount,
								bib: null
							};
						});
					} else {
						return [];
					}
					break;
				case 'sirsi':
					let sirsiFineDetails = await (
						await fetch(
							`${process.env.VUE_APP_API_ENDPOINT}/v2/${this.keyword}/sirsidynix/patron/details/${patronBarcode}/${patronPin}`,
							{
								method: 'GET',
								headers: { 'Content-Type': 'application/json' }
							}
						)
					).json();
					return [
						{
							id: null,
							description: null,
							amountPaid: null,
							amount:
								sirsiFineDetails.data !== undefined
									? sirsiFineDetails.data.moneyOwed
									: null,
							currency: null,
							bib: null
						}
					];
					break;
				case 'polaris':
					let polarisFineDetails = await (
						await fetch(
							`${process.env.VUE_APP_API_ENDPOINT}/v1/${this.keyword}/polaris/account/${patronBarcode}/${patronPin}`,
							{
								method: 'GET',
								headers: { 'Content-Type': 'application/json' }
							}
						)
					).json();
					if (
						polarisFineDetails.PatronAccountGetRows !== undefined &&
						polarisFineDetails.PatronAccountGetRows !== null
					) {
						return polarisFineDetails.PatronAccountGetRows.map(
							fine => {
								return {
									id: fine.TransactionID,
									description: fine.FeeDescription,
									amountPaid:
										fine.TransactionAmount -
										fine.OutstandingAmount,
									amount: fine.TransactionAmount,
									bib: null
								};
							}
						);
					} else {
						return [];
					}
					break;
			}
		}
	}
};
